import * as P from '@radix-ui/react-progress';
import { cn } from '../../lib/utils.ts';

export function Progress({
  value,
  className,
  tone = 'accent',
}: {
  value: number;
  className?: string;
  tone?: 'accent' | 'ok' | 'warn' | 'bad';
}) {
  const color = { accent: 'bg-accent', ok: 'bg-ok', warn: 'bg-warn', bad: 'bg-bad' }[tone];
  return (
    <P.Root
      className={cn('relative h-2 w-full overflow-hidden rounded-full bg-fill', className)}
      value={value}
    >
      <P.Indicator
        className={cn('h-full rounded-full transition-[width] duration-500', color)}
        style={{ width: `${String(Math.min(100, Math.max(0, value)))}%` }}
      />
    </P.Root>
  );
}
